import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
const colorStrokeFocus = 'var(--colorStrokeFocus, var(--coreColorBlue600))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const colorStrokeInverseStandard = 'var(--colorStrokeInverseStandard, var(--coreColorNeutral700))'
import { BodyText } from '@calendly/ui/components/typography'
import { useFlag } from '@calendly/feature-check-react'

import { useI18n } from 'locales'
import _Container from "navigator-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/spotpicker/navigator.js?styleId=Container";
import _TabLabel from "navigator-TabLabel.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/spotpicker/navigator.js?styleId=TabLabel";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
})

const TabLabel = /*#__PURE__*/styled(BareButton, null, {
  displayName: "TabLabel",
  styles: _TabLabel
})

export const Navigator = ({ currentTab, setCurrentTab, showPollLabel }) => {
  const { i18n } = useI18n()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const timeLabel = showPollLabel
    ? i18n.t('booking.templates.poll.meeting_poll_label')
    : bookingAppRedesign
      ? i18n.t('booking.templates.available_times')
      : i18n.t('booking.templates.select_a_time')

  const tabs = [
    { name: 'time', label: timeLabel },
    { name: 'schedule', label: i18n.t('booking.templates.your_schedule') }
  ]

  return (
    <Container>
      {tabs.map(
        ({ name, label }) => (
          <TabLabel key={name} selected={currentTab === name} onClick={() => setCurrentTab(name)}>
            <BodyText as="div" size="medium" weight={currentTab === name ? 'bold' : 'normal'}>
              {label}
            </BodyText>
          </TabLabel>
        )
      )}
    </Container>
  )
}
